/* eslint-disable no-new-func */

export default {
  getOptions () {
    if (_options !== null) {
      return Promise.resolve(_options)
    } else {
      if (_promise === null) {
        _promise = fetch(BASE_URL + 'konfigurator.json')
          .then(response => {
            return response.json()
          })
          .then(data => {
            return makeOptions(data)
          })
          .then(options => {
            _options = options
            return options
          })
      }
      return _promise
    }
  }
}

let _options = null
let _promise = null

function makeOptions (opts) {
  let models = {}
  let structures = {}
  for (let key in opts.models) {
    let m = makeModels(opts.models[key])
    let s = m['.structures']
    delete m['.structures']
    models[key] = m
    structures[key] = s
  }
  opts.options = models
  opts.structures = structures
  opts.models = makeModelTree(models)
  Object.freeze(opts)
  return opts
}

function makeModelTree (models_) {
  let tree = {}
  for (let key in models_) {
    tree[key] = {}
    let models = models_[key]
    for (let key2 in models) {
      let model = models[key2]
      let subgroup = model['.subgroup']
      if (!tree[key][subgroup]) {
        tree[key][subgroup] = []
      }
      tree[key][subgroup].push(key2)
    }
  }
  return tree
}

function makeModels (opts) {
  let models = {}
  let presets = {}
  let structures = {}
  for (let prop in opts) {
    if (prop[0] === '.') {
      let name = prop.substr(1)
      presets[name] = opts[prop]
      presets[name]['.fixup'] = true
    } else {
      models[prop] = opts[prop]
    }
  }
  for (let name in presets) {
    fixupPreset(presets[name], presets)
  }
  for (let name in models) {
    fixupModel(models[name], presets)
    structures[name] = models[name].structure
    delete models[name].structure
  }
  models['.structures'] = structures
  return models
}

function makeStructure (s) {
  if (s === undefined || s === null) {
    return {}
  }
  return s.map(section => ({
    ...section,
    ...(('condition' in section) && {condition: compileCondition(section.condition)}),
    items: section.items.map(item =>
      typeof item === 'string' ? {name: item} : item
    ).map(item => {
      if ('condition' in item) {
        return {
          ...item,
          condition: compileCondition(item.condition)
        }
      } else {
        return item
      }
    })
  }))
}

function fixup (data) {
  let options = {}
  for (let prop in data) {
    if (prop[0] !== '.') {
      options[prop] = data[prop]
      delete data[prop]
    }
  }
  for (let name in options) {
    let opt = options[name]
    if (opt === undefined) {
      continue
    }
    let vals = {}
    for (let key in opt) {
      if (key[0] !== '.') {
        vals[key] = opt[key]
        delete opt[key]
      }
    }
    opt.values = vals
    opt.title = opt['.title']
    if ('.filter' in opt) {
      opt.filter = compileFilter(opt['.filter'])
      delete opt['.filter']
    }
    delete opt['.title']
  }
  data.options = options
  data.structure = makeStructure(data['.structure'])
  data.constraints = (data['.constraints'] || []).map(constraint => compileConstraint(constraint))
  data.modelName = data['.model-name'] || {}
  data.fixed = data['.fixed'] || {}
  delete data['.structure']
}

function fixupPreset (preset, presets) {
  if (preset['.fixup_complete']) {
    return
  }
  if (preset['.working'] === true) {
    throw new Error('dependency loop')
  }
  preset['.working'] = true
  fixup(preset)
  if (preset['.extends']) {
    if (presets[preset['.extends']]) {
      fixupPreset(presets[preset['.extends']])
      extend(preset.options, presets[preset['.extends']].options)
      extend(preset.structure, presets[preset['.extends']].structure)
      extend(preset.constraints, presets[preset['.extends']].constraints)
      extend(preset.modelName, presets[preset['.extends']].modelName)
    } else {
      throw new Error('invalid extends: ' + preset['.extends'], preset)
    }
    delete preset['.extends']
  }
  delete preset['.working']
  preset['.fixup_complete'] = true
}

let structureIdCount = 0

function fixupModel (model, presets) {
  fixup(model)
  if (model['.extends']) {
    if (presets[model['.extends']]) {
      extend(model.options, presets[model['.extends']].options)
      extend(model.structure, presets[model['.extends']].structure)
      extend(model.fixed, presets[model['.extends']].fixed)
      extend(model.constraints, presets[model['.extends']].constraints)
      extend(model.modelName, presets[model['.extends']].modelName)
      delete model['.extends']
    } else {
      throw new Error('invalid extends: ' + model['.extends'])
    }
  }
  for (let key in model.structure) {
    model.structure[key].id = 's' + (structureIdCount++)
  }
}

function compileFilter (filter) {
  let params = filter.params || []
  let paramNames = params.map(p => typeof p === 'object' ? p.name : p)
  let typeConversion = params.reduce((code, param) => {
    if (typeof param === 'object' && 'type' in param) {
      switch (param.type) {
        case 'number':
        case 'float':
          return code + param.name + ' = parseFloat(' + param.name + '); '
        case 'integer':
          return code + param.name + ' = parseInt(' + param.name + '); '
        case 'string':
          return code + param.name + ' = ' + param.name + '.toString(); '
        default:
          return code
      }
    } else {
      return code
    }
  }, '')
  let itemName = 'item'
  if (typeof filter.item === 'string') {
    itemName = filter.item
  } else if (typeof filter.item === 'object') {
    itemName = filter.item.name || itemName
    if ('type' in filter.item) {
      switch (filter.item.type) {
        case 'number':
        case 'float':
          typeConversion = itemName + ' = parseFloat(' + itemName + '); ' + typeConversion
          break
        case 'integer':
          typeConversion = itemName + ' = parseInt(' + itemName + '); ' + typeConversion
          break
        case 'string':
          typeConversion = itemName + ' = ' + itemName + '.toString(); ' + typeConversion
          break
        default:
      }
    }
  }
  return {
    params: paramNames,
    func: new Function('item', ...paramNames, typeConversion + 'return (' + filter.func + ')')
  }
}

function compileCondition (condition) {
  let params = condition.params || []
  let paramNames = params.map(p => typeof p === 'object' ? p.name : p)
  let typeConversion = params.reduce((code, param) => {
    if (typeof param === 'object' && 'type' in param) {
      switch (param.type) {
        case 'number':
        case 'float':
          return code + param.name + ' = parseFloat(' + param.name + '); '
        case 'integer':
          return code + param.name + ' = parseInt(' + param.name + '); '
        case 'string':
          return code + param.name + ' = ' + param.name + '.toString(); '
        default:
          return code
      }
    } else {
      return code
    }
  }, '')
  return {
    params: paramNames,
    func: new Function(...paramNames, typeConversion + 'return (' + condition.func + ')')
  }
}

function compileConstraint (constraint) {
  if (constraint.type === 'sum') {
    constraint.fixed_params = [constraint.sum]
    constraint.func = (typeof constraint.sum === 'string' ? constraint.sum : constraint.sum.name) + ' === (' + constraint.properties.map(p => typeof p === 'string' ? p : p.name).join(' + ') + ')'
    constraint.params = constraint.properties
  } else if (constraint.type !== 'func') {
    return {
      params: [],
      fixed_params: [],
      func: () => true
    }
  }
  let params = constraint.params || []
  let fixedParams = constraint.fixed_params || []
  let func = constraint.func || 'true'
  let paramNames = params.map(p => typeof p === 'object' ? p.name : p)
  let fixedParamNames = fixedParams.map(p => typeof p === 'object' ? p.name : p)
  let typeConversion = [...params, ...fixedParams].reduce((code, param) => {
    if (typeof param === 'object' && 'type' in param) {
      switch (param.type) {
        case 'number':
        case 'float':
          return code + param.name + ' = parseFloat(' + param.name + '); '
        case 'integer':
          return code + param.name + ' = parseInt(' + param.name + '); '
        case 'string':
          return code + param.name + ' = ' + param.name + '.toString(); '
        default:
          return code
      }
    } else {
      return code
    }
  }, '')
  let logging = ''
  return {
    params: paramNames,
    fixed_params: fixedParamNames,
    func: new Function(...(fixedParamNames), ...(paramNames), typeConversion + logging + 'return (' + func + ')')
  }
}

function extend (dest, source) {
  for (let prop in source) {
    if (!(prop in dest)) {
      dest[prop] = deepCopy(source[prop])
    }
  }
}

function deepCopy (o) {
  if (Array.isArray(o)) {
    return o.map(i => deepCopy(i))
  } else if (typeof o === 'object') {
    let n = {}
    for (let prop in o) {
      n[prop] = deepCopy(o[prop])
    }
    return n
  } else {
    return o
  }
}



// WEBPACK FOOTER //
// ./src/Options.js